import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { FaEye, FaEdit, FaTrash, FaPlus, FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight,FaUserCheck } from 'react-icons/fa';
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment/moment";
import { useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
  Button,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Table,
  
} from "reactstrap";
import {NavLink, useNavigate } from "react-router-dom";
import { FaLocationArrow } from "react-icons/fa";
//  import "../styles/DataRecapComponent.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import MyNavbar from "../map/Navbar";
import "./Datarecap.css"

import Footer from "./Footer";
import { Layout } from "lucide-react";
import EditModal from "./EditModal";
import Filters from "./datarecap/Filters";
import { kecamatanOptions } from "./datarecap/constants";
import LocationModal from "./datarecap/LocationModal";
import PhotoModal from "./datarecap/PhotoModal";
import DetailInfoModal from "./datarecap/DetailInfoModal";
import DataBacklog from "./datarecap/DataBacklog";
import { useDebouncedTextFilters } from "../hooks/useDebouncedTextFilters";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});


const DataRecapComponent = ({ onStatisticsUpdate }) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [desaOptions, setDesaOptions] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [username, setUsername] = useState("");
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [photoUrl, setPhotoUrl] = useState('');
  const [isBacklog, setIsBacklog] = useState(false);
  const [desaKelurahan, setDesaKelurahan] = useState("");
  const [kecamatan, setKecamatan] = useState("");
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isBacklogModalOpen, setIsBacklogModalOpen] = useState(false);
  const [backlogData, setBacklogData] = useState(null);
const [detailData, setDetailData] = useState(null);
const [totalPages, setTotalPages] = useState(0);
const [isMobile, setIsMobile] = useState(false);

  const [filters, setFilters] = useState({
    kecamatan: "",
    desaKelurahan: "",
    kategori: "",
    user: "", 
    statusrumah: "",
    searchName: "",
    searchAlamat: "",
     tanpaFoto: 'false',
    koordinatTidakValid: 'false'
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const rowsPerPage = 25;
  const [errors, setErrors] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const { user } = useSelector((state) => state.authAdmin || {});
  const [selectedKecamatan, setSelectedKecamatan] = useState("");
    // const [data, setData] = useState([]);
    // const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    // const [totalPages, setTotalPages] = useState(0);
    // const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
  const [isPreviewing, setIsPreviewing] = useState(false);
  const [fotoRumah, setFotoRumah] = useState(null);
  const [photoFile, setPhotoFile] = useState(null);
  const videoRef = useRef(null);
  const fetchIdRef = useRef(0);
  const abortControllerRef = useRef(null);
  const queryFilters = useDebouncedTextFilters(filters, ["searchName", "searchAlamat"]);

  const fetchData = useCallback(async (page = 1, limit = itemsPerPage) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;
    const fetchId = ++fetchIdRef.current;

    setIsLoading(true);
    try {
      const trimmedSearchName = queryFilters.searchName?.trim();
      const trimmedSearchAlamat = queryFilters.searchAlamat?.trim();
      const params = {
        page,
        limit,
        ...(trimmedSearchName && { searchName: trimmedSearchName }),
        ...(trimmedSearchAlamat && { searchAlamat: trimmedSearchAlamat }),
        ...(queryFilters.kecamatan && queryFilters.kecamatan !== "" && queryFilters.kecamatan !== "Semua Kecamatan" && { kecamatan: queryFilters.kecamatan }),
        ...(queryFilters.desaKelurahan && queryFilters.desaKelurahan !== "" && queryFilters.desaKelurahan !== "Pilih Desa/Kelurahan" && { desaKelurahan: queryFilters.desaKelurahan }),
        ...(queryFilters.kategoriStatusRumah && queryFilters.kategoriStatusRumah !== "" && queryFilters.kategoriStatusRumah !== "Pilih Kategori & Status Rumah" && { kategoriStatusRumah: queryFilters.kategoriStatusRumah }),
        ...(queryFilters.kategori && !queryFilters.kategoriStatusRumah && { kategori: queryFilters.kategori }),
        ...(queryFilters.statusrumah && !queryFilters.kategoriStatusRumah && { statusrumah: queryFilters.statusrumah }),
        ...(queryFilters.user && { user: queryFilters.user }),
        ...(queryFilters.tanpaFoto === "true" && { tanpaFoto: "true" }),
        ...(queryFilters.koordinatTidakValid === "true" && { koordinatTidakValid: "true" }),
      };
      const response = await axios.get(`${process.env.REACT_APP_URL}/getquestionnaires`, {
        params,
        withCredentials: true,
        signal: controller.signal,
      });

      if (fetchId !== fetchIdRef.current) return;

      if (response.status === 200) {
        const responseData = response.data;
        setData(responseData.data);
        setTotalPages(responseData.pagination.totalPages);
        setCurrentPage(responseData.pagination.currentPage);
        setError(null);
      }
    } catch (error) {
      if (error.code === "ERR_CANCELED" || error.name === "CanceledError") return;
      if (fetchId !== fetchIdRef.current) return;
      console.error("Error fetching data", error);
      setError("Terjadi kesalahan saat memuat data.");
    } finally {
      if (fetchId === fetchIdRef.current) {
        setIsLoading(false);
      }
    }
  }, [queryFilters, itemsPerPage]);

  useEffect(() => {
    fetchData(currentPage, itemsPerPage);
  }, [currentPage, itemsPerPage, fetchData]);
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
    const handlePageChange = (page) => {
      if (page < 1 || page > totalPages || page === currentPage) return;
      setCurrentPage(page);
    };
    
    const handleItemsPerPageChange = (event) => {
      const newLimit = parseInt(event.target.value);
      setItemsPerPage(newLimit);
      setCurrentPage(1); 
    };
   
  // Delete data function
  const deleteData = async (id) => {
    const userConfirmed = window.confirm('Apakah Anda yakin ingin menghapus data ini?');
    if (userConfirmed) {
    try {
      await axios.delete(`${process.env.REACT_APP_URL}/delete/${id}`, { withCredentials: true });
      alert("Data berhasil dihapus.");
      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error);
      alert("Gagal menghapus data. Silakan coba lagi.");
    }
  }
};
const deleteByDesa = async (desaKelurahan) => {
  const userConfirmed = window.confirm('Apakah Anda yakin ingin menghapus data ini?');
  if (userConfirmed) {
  try {
    const response = await axios.delete(`${process.env.REACT_APP_URL}/questionnaires/desa/${desaKelurahan}`,{withCredentials: true});
    alert(response.data.message);
  } catch (error) {
    alert(error.response?.data?.message || "Terjadi kesalahan saat menghapus data");
  }
}
};
const handleDelete = async () => {
  if (!desaKelurahan) {
    alert("Pilih desaKelurahan terlebih dahulu");
    return;
  }

  try {
    await deleteByDesa(desaKelurahan);
  } catch (error) {
    console.error(error);
  }
};

  
  useEffect(() => {
    // const kecamatanDesa = {
    //   Taliwang: ["Menala", "Dalam", "Sampir", "Kuang", "Bugis", "Arab Kenangan", "Telaga Bertong", "Tamekan", "Seloto", "Lamunga", "Batu Putih", "Banjar", "Sermong", "Labuhan Kertasari", "Labuhan Lalar", "Lalar Liang"],
    //   Seteluk: ["Seteluk Tengah", "Seteluk Atas", "Seran", "Rempe", "Tapir", "Air Suning", "Kelanir", "Lamusung", "Desa Loka", "Meraran"],
    //   PotoTano: ["Poto Tano", "Kokarlian", "Tambak Sari", "Tebo", "Senayan", "Kiantar", "Tuananga", "Mantar"],
    //   BrangRea: ["Lamuntet", "Rarak Ronges", "Bangkat Monteh", "Moteng", "Tepas Sepakat", "Tepas", "Sapugara Bree", "Seminar Salit", "Desa Beru"],
    //   BrangEne: ["Lampok", "Mujahidin", "Kalimantong", "Manemeng", "Mataiyang", "Mura"],
    //   Jereweh: ["Dasan Anyar", "Goa", "Beru", "Belo"],
    //   Maluk: ["Benete", "Bukit Damai", "Mantun", "Pasir Putih", "Maluk"],
    //   Sekongkang: ["Talonang Baru", "Tatar", "Ai Kangkung", "Sekongkang Atas", "Tongo", "Kemuning", "Sekongkang Bawah"],
    // };
    const kecamatanDesa = {
      "Taliwang": ["Menala", "Dalam", "Sampir", "Kuang", "Bugis", "Arab Kenangan", "Telaga Bertong", "Tamekan", "Seloto", "Lamunga", "Batu Putih", "Banjar", "Sermong", "Labuhan Kertasari", "Labuhan Lalar", "Lalar Liang"],
      "Seteluk": ["Seteluk Tengah", "Seteluk Atas", "Seran", "Rempe", "Tapir", "Air Suning", "Kelanir", "Lamusung", "Desa Loka", "Meraran"],
      "Poto Tano": ["Poto Tano", "Kokarlian", "Tambak Sari", "Tebo", "Senayan", "Kiantar", "Tuananga", "Mantar"],
      "Brang Rea": ["Lamuntet", "Rarak Ronges", "Bangkat Monteh", "Moteng", "Tepas Sepakat", "Tepas", "Sapugara Bree", "Seminar Salit", "Desa Beru"],
      "Brang Ene": ["Lampok", "Mujahidin", "Kalimantong", "Manemeng", "Mataiyang", "Mura"],
      "Jereweh": ["Dasan Anyar", "Goa", "Beru", "Belo"],
      "Maluk": ["Benete", "Bukit Damai", "Mantun", "Pasir Putih", "Maluk"],
      "Sekongkang": ["Talonang Baru", "Tatar", "Ai Kangkung", "Sekongkang Atas", "Tongo", "Kemuning", "Sekongkang Bawah"],
    };

    if (selectedItem && selectedItem.kecamatan) {
     // setDesaOptions(kecamatanDesa[selectedItem.kecamatan.replace(/\s/g, "")] || []);
      setDesaOptions(kecamatanDesa[selectedItem.kecamatan] || []);
    } else {
      setDesaOptions([]);
    }
  }, [selectedItem]);
  useEffect(() => {
    const fetchSurveyorName = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}/me`, {
          withCredentials: true,
        });
  
        if (response.status === 200) {
          setSelectedItem((prevData) => ({
            ...prevData,
            namaSurveyor: data.Admin?.username || "Data tidak tersedia",
          }));
        } else {
          console.error("Gagal mengambil nama surveyor:", response.statusText);
          navigate("/login");
        }
      } catch (error) {
        console.error("Error mengambil nama surveyor:", error);
        navigate("/login");
      }
    };
    fetchSurveyorName();
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}/userfilter`, {
          withCredentials: true,
          
        });
        if (response.status === 200) {
          setUserOptions(response.data);
        } else {
          console.error("Failed to fetch users:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUsers();
  }, []);
  
  const handleDetailModalOpen = async (item) => {
    setIsDetailModalOpen(true);
    setDetailData({ ...item, _loadingBantuan: true });
    try {
      const response = await axios.get(`${process.env.REACT_APP_URL}/getquestionnaires/${item.id}`, {
        withCredentials: true,
      });
      if (response.status === 200 && response.data) {
        setDetailData(response.data);
        return;
      }
    } catch (error) {
      console.error("Error fetching questionnaire detail:", error);
    }
    setDetailData(item);
  };

  const handleBacklogModalOpen = async (item) => {
    try {
      // Fetch individual item data to get Backlogs
      const response = await axios.get(`${process.env.REACT_APP_URL}/getquestionnaires/${item.id}`, {
        withCredentials: true,
      });
      
      if (response.status === 200) {
        setBacklogData(response.data);
        setIsBacklogModalOpen(true);
      } else {
        console.error("Failed to fetch individual item data");
        setBacklogData(item); // Fallback to table data
        setIsBacklogModalOpen(true);
      }
    } catch (error) {
      console.error("Error fetching individual item data:", error);
      setBacklogData(item); // Fallback to table data
      setIsBacklogModalOpen(true);
    }
  };
  
  const handleDetailModalClose = () => {
    setDetailData(null);
    setIsDetailModalOpen(false);
  };

  const handleBacklogModalClose = () => {
    setBacklogData(null);
    setIsBacklogModalOpen(false);
  };
  

  const calculateStatistics = (data) => {
    const stats = {
      totalRumahLayakHuni: 0,
      totalRumahTidakLayakHuni: 0,
      byKecamatan: {},
    };

    data.forEach((item) => {
      if (item.kategori === "Rumah Layak Huni") {
        stats.totalRumahLayakHuni += 1;
      } else if (item.kategori === "Rumah Tidak Layak Huni") {
        stats.totalRumahTidakLayakHuni += 1;
      }

      if (!stats.byKecamatan[item.kecamatan]) {
        stats.byKecamatan[item.kecamatan] = {
          rumahLayakHuni: 0,
          rumahTidakLayakHuni: 0,
        };
      }

      if (item.kategori === "Rumah Layak Huni") {
        stats.byKecamatan[item.kecamatan].rumahLayakHuni += 1;
      } else if (item.kategori === "Rumah Tidak Layak Huni") {
        stats.byKecamatan[item.kecamatan].rumahTidakLayakHuni += 1;
      }
    });

    return stats;
  };


  const handleFilterChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    setFilters(prevFilters => {
      const newFilters = { ...prevFilters };
      if (type === "checkbox") {
        newFilters[name] = checked ? "true" : "";
      } else {
        newFilters[name] = value;
        if (name === "kecamatan") {
          newFilters.desaKelurahan = "";
        }
        if (name === "kategoriStatusRumah") {
          if (value === "" || value === "Pilih Kategori & Status Rumah") {
            newFilters.kategoriStatusRumah = "";
            newFilters.kategori = "";
            newFilters.statusrumah = "";
          } else {
            const [kategori, statusrumah] = value.split(" - ");
            newFilters.kategoriStatusRumah = value;
            newFilters.kategori = kategori;
            newFilters.statusrumah = statusrumah;
          }
        } else {
          newFilters[name] = value;
        }
  
      }
      
      return newFilters;
    });
    setCurrentPage(1);
  };
  const handleToggleExpand = async (index, id) => {
    if (expandedRows.includes(index)) {
      setExpandedRows(expandedRows.filter(row => row !== index));
      setSelectedItem(null); 
    } else {
      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}/maps/${id}`,{
          withCredentials:true
        });
        if (response.status === 200) {
          setSelectedItem(response.data); 
          setModalOpen(true); 
        } else {
          console.error("Failed to fetch detail data:", response.statusText);
          setErrorMessage("Gagal mengambil data detail.");
        }
      } catch (error) {
        console.error("Error fetching detail data:", error);
        setErrorMessage("Terjadi kesalahan saat mengambil data detail.");
        setModalOpen(true);
      }
    };
  };


  // Filter nama/alamat/KTP sudah di backend (decrypt dulu, baru filter).
  // Jangan double-filter ciphertext di client — tampilkan data server apa adanya.
  const filteredData = Array.isArray(data) ? data : [];
  const currentRows = filteredData;

  const handleEditClick = (item) => {
    setSelectedItem({
      ...item,
      kecamatan: item.kecamatan || "", 
      desaKelurahan: item.desaKelurahan || "",
      kategori: item.kategori || ""
    });
    setSelectedItem(item);
    setIsModalOpen(true);
  };
  const handleModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };
  const handleSaveData = async (formData, isFormData) => {
    try {
      let response;
      if (isFormData) {
        response = await axios.put(
          `${process.env.REACT_APP_URL}/updatequestionnaires/${selectedItem.id}`,
          formData,
          { 
            withCredentials: true,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );
      } else {
        response = await axios.put(
          `${process.env.REACT_APP_URL}/updatequestionnaires/${selectedItem.id}`,
          formData,
          { withCredentials: true }
        );
      }
      
      setIsModalOpen(false);
      alert("Data berhasil diperbarui.");
      
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error);
      
      if (error.response) {
        console.log("Server response:", error.response.data);
        alert(error.response.data.message || "Terjadi kesalahan saat memperbarui data.");
      } else {
        alert("Terjadi kesalahan jaringan atau server.");
      }
    }
  };
const handleVerifikasiBantuan = async (id, formData, isFormData) => {
   console.log("ID yang diterima:", id);
  console.log("formData:", formData);

  if (!id) {
    alert("ID tidak ditemukan!");
    return;
  }
  try {
    let response;
    if (isFormData) {
      response = await axios.put(
        `${process.env.REACT_APP_URL}/updateverifikasiBantuan/${id}`,
        formData,
        { 
          withCredentials: true,
          headers: { "Content-Type": "multipart/form-data" }
        }
      );
    } else {
      response = await axios.put(
        `${process.env.REACT_APP_URL}/updateverifikasiBantuan/${id}`,
        formData,
        { withCredentials: true }
      );
    }
    alert("Data berhasil di verifikasi bantuan.");
  } catch (error) {
    console.error("Error updating data:", error);
  }
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    setSelectedItem((prevData) => {
      let updatedData = {
        ...prevData,
        [name]: value,
        ...(name === "manualTitikKoordinatRumah" ? { titikKoordinatRumah: "" } : {}),
        ...(name === "titikKoordinatRumah" ? { manualTitikKoordinatRumah: "" } : {})
      };
      if (name === "jumlahKK" && parseInt(value) > 1) {
        setIsBacklog(true);
      } else if (name === "jumlahKK" && parseInt(value) <= 1) {
        setIsBacklog(false);
      }
      if (name === "kepemilikanKamarMandiDanJamban" && value === "Tidak Ada") {
        updatedData = {
          ...updatedData,
          jumlahJamban: 0,
          jenisKloset: "Tidak Ada",
          jenisTangkiSeptik: "Tidak Ada",
          materialTangkiSeptik: "Tidak Ada",
          alasTangkiSeptik: "Tidak Ada",
          lubangPenyedotan: "Tidak Ada",
          posisiTangkiSeptik: "Tidak Ada",
          jarakTangkiSeptikDenganSumberAir: "Tidak Ada",
        };
      }
      if (name === "statusrumah" && value === "Tidak Berpenghuni") {
        updatedData = {
          ...updatedData,
          tanggallahir: null,
          jenisKelamin: "Kosong",
          nomorKK: "0000000000000000",
          nomorKTP: "0000000000000000",
          asalKTP: "0",
          jumlahKK: "0",
          jumlahPenghuni: "0",
          pendidikanTerakhir: "0",
          pekerjaan: "0",
          penghasilan: "0",
          statusKepemilikanRumah: "0",
          asetRumahDiTempatLain: "0",
          statusKepemilikanTanah: "0",
          asetTanahDiTempatLain: "0",
          sumberPenerangan: "0",
          dayaListrik: "0",
          bantuanPerumahan: "0",
         // materialLantaiTerluas: "0",
         // materialPenutupAtapTerluas: "0",
          buanganAirLimbahRumahTangga: "0",
          saranaPengelolaanLimbahCair: "0",
          pemiliharaanSaranaPengelolaanLimbah: "0",
          jenisTempatPembuanganAirTinja: "0",
          kepemilikanKamarMandiDanJamban: "0",
          jumlahJamban: "0",
          jenisKloset: "0",
          jenisTangkiSeptik: "0",
          materialTangkiSeptik: "0",
          alasTangkiSeptik: "0",
          lubangPenyedotan: "0",
          posisiTangkiSeptik: "0",
          jarakTangkiSeptikDenganSumberAir: "0",
          sumberAirMinum: "0",
        };
      }
  
      return updatedData;
    });
  };
  
  const handleUploadExcel = async () => {
    if (!selectedFile) {
      alert("Silakan pilih file untuk diunggah.");
      return;
    }
  
    const formData = new FormData();
    formData.append("file", selectedFile);
  
    try {
      await axios.post(`${process.env.REACT_APP_URL}/uploadexcel`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });
  
      alert("File berhasil diunggah!");
      setSelectedFile(null); // Reset setelah berhasil upload
    } catch (error) {
      console.error("Error uploading file:", error);
      alert(
        error.response?.data?.message || "Terjadi kesalahan saat mengunggah file."
      );
    }
  };
  
 
  const handleExportExcel = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/download`,
        {
          params: { kecamatan: selectedKecamatan },
          responseType: "blob", 
          withCredentials: true,
        }
      );

      // Unduh file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "questionnaires.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      alert("Gagal mengunduh data. Pastikan Anda memilih kecamatan yang benar.");
    }
  };
  //foto 
 const handleFotoClick = async (id, item) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_URL}/getquestionnaires/${id}`, {
      withCredentials: true
    });
    if (response.data && response.data.fotos && response.data.fotos.length > 0) {
      setPhotoUrl(`${process.env.REACT_APP_URL}/${response.data.fotos[0].foto_rumah}`);
      setShowPhotoModal(true);
      setSelectedItem(item); 
    } else {
      alert('No photo available for this entry.');
    }
  } catch (error) {
    console.error('Error fetching photo', error);
  }
};

  const handleClosePhotoModal = () => {
    setShowPhotoModal(false);
    setPhotoUrl('');
  };
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}/me`, {
          withCredentials: true
        });
  
        if (response.status === 200) {
          setUsername(response.data.username);
        } else {
          navigate("/login");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        navigate("/login");
      }
    };
  
    fetchUser();
  }, [navigate]);
  const validateDate = (date) => {
    const datePattern = /^(0[1-9]|[12][0-9]|3[01])[-/](0[1-9]|1[0-2])[-/]\d{4}$/;
    return datePattern.test(date);
};
const getPageNumbers = () => {
  const pageNumbers = [];
  const maxVisiblePages = 5;
  
  if (totalPages <= maxVisiblePages) {
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
  } else {
    pageNumbers.push(1);
    let startPage = Math.max(2, currentPage - 1);
    let endPage = Math.min(totalPages - 1, currentPage + 1);
    if (currentPage <= 3) {
      endPage = Math.min(maxVisiblePages - 1, totalPages - 1);
    }
    if (currentPage >= totalPages - 2) {
      startPage = Math.max(2, totalPages - maxVisiblePages + 2);
    }
    if (startPage > 2) {
      pageNumbers.push('...');
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    if (endPage < totalPages - 1) {
      pageNumbers.push('...');
    }
    if (totalPages > 1) {
      pageNumbers.push(totalPages);
    }
  }
  
  return pageNumbers;
};
const contentStyle = isMobile 
? {} // No margins on mobile
: { marginLeft: "250px", marginRight: "20px" };
return (
  <div className="data-content-wrapper">
      <div className="main-content" style={contentStyle}>
        <Container fluid className="data-recap-page p-2 p-md-4">
        {error && (
          <Row className="mb-4">
            <Col>
              <Alert color="danger">{error}</Alert>
            </Col>
          </Row>
        )}
<Filters
  filters={filters}
  user={user}
  userOptions={userOptions}
  kecamatanOptions={kecamatanOptions}
  onChange={handleFilterChange}
/>
        {/* Action buttons */}
        <Row className="mb-4">
          <Col>
            <div className="d-flex flex-wrap gap-3">
              {/* Add Data Button */}
              <Button
                color="primary"
                className="btn-custom text-center px-4"
                style={{
                  borderRadius: "6px",
                  backgroundImage: "linear-gradient(135deg, #1abc9c, #3498db)",
                  border: "none",
                }}
              >
                <NavLink
                  to="/questionnaire"
                  className="d-flex align-items-center justify-content-center text-white"
                  style={{ textDecoration: "none" }}
                >
                  <FaPlus className="me-2" />
                  Tambah Data
                </NavLink>
              </Button>

              {/* Admin Upload File Button */}
              {user && user.role === "admin" && (
                <>
                  <input
                    type="file"
                    id="fileInput"
                    style={{ display: "none" }}
                    onChange={(e) => setSelectedFile(e.target.files[0])}
                  />
                  <Button
                    color="primary"
                    onClick={() => document.getElementById("fileInput").click()}
                    className="px-4 fw-bold"
                    style={{
                      borderRadius: "6px",
                      backgroundImage: "linear-gradient(135deg, #1abc9c, #3498db)",
                      border: "none",
                    }}
                  >
                    {selectedFile ? `File: ${selectedFile.name}` : "Pilih File"}
                  </Button>
                  <Button
                    color="success"
                    onClick={handleUploadExcel}
                    className="px-4 fw-bold"
                    disabled={!selectedFile}
                  >
                    Upload
                  </Button>
                </>
              )}
            </div>
          </Col>
        </Row>

        {/* Admin export and delete controls */}
        {user && user.role === "admin" && (
          <Row className="mb-4">
            <Col md={6}>
              <div className="p-3 bg-light rounded border">
                <h5 className="mb-3">Export Data</h5>
                <div className="form-group mb-3">
                  <label htmlFor="exportKecamatan" className="form-label fw-bold">Pilih Kecamatan:</label>
                  <select
                    id="exportKecamatan"
                    className="form-select mb-3"
                    value={selectedKecamatan}
                    onChange={(e) => setSelectedKecamatan(e.target.value)}
                  >
                    <option value="">Semua Kecamatan</option>
                    <option value="Taliwang">Taliwang</option>
                    <option value="Seteluk">Seteluk</option>
                    <option value="Poto Tano">Poto Tano</option>
                    <option value="Brang Rea">Brang Rea</option>
                    <option value="Brang Ene">Brang Ene</option>
                    <option value="Jereweh">Jereweh</option>
                    <option value="Maluk">Maluk</option>
                    <option value="Sekongkang">Sekongkang</option>
                  </select>
                  <Button
                    color="primary"
                    onClick={handleExportExcel}
                    style={{
                      borderRadius: "6px",
                      backgroundImage: "linear-gradient(135deg, #1abc9c, #3498db)",
                      border: "none",
                      width: "100%",
                    }}
                  >
                    Export to Excel
                  </Button>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="p-3 bg-light rounded border">
                <h5 className="mb-3">Hapus Data</h5>
                <div className="form-group mb-3">
                  <label htmlFor="deleteKecamatan" className="form-label fw-bold">Pilih Kecamatan:</label>
                  <select
                    id="deleteKecamatan"
                    className="form-select mb-3"
                    value={kecamatan}
                    onChange={(e) => setKecamatan(e.target.value)}
                  >
                    <option value="">Pilih Kecamatan</option>
                    {Object.keys(kecamatanOptions).map((key) => (
                      <option key={key} value={key}>
                        {key}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="deleteDesaKelurahan" className="form-label fw-bold">Pilih Desa/Kelurahan:</label>
                  <select
                    id="deleteDesaKelurahan"
                    className="form-select mb-3"
                    value={desaKelurahan}
                    onChange={(e) => setDesaKelurahan(e.target.value)}
                    disabled={!kecamatan}
                  >
                    <option value="">Pilih Desa/Kelurahan</option>
                    {kecamatan &&
                      kecamatanOptions[kecamatan].map((desa) => (
                        <option key={desa} value={desa}>
                          {desa}
                        </option>
                      ))}
                  </select>
                </div>
                <Button
                  color="danger"
                  onClick={handleDelete}
                  style={{
                    width: "100%",
                    borderRadius: "6px",
                  }}
                >
                  Hapus Data
                </Button>
              </div>
            </Col>
          </Row>
        )}

        {/* Data Table */}
        <div className="table-responsive rounded border">
        <Table hover responsive className="mb-0">
          <thead className="table-light table-header">
              <tr>
                <th className="align-middle">No</th>
                <th className="align-middle">Nomor Blok</th>
                <th className="align-middle">Nomor Peta</th>
                <th className="align-middle">Nama Lengkap KK</th>
                <th className="align-middle">Alamat Rumah</th>
                <th className="align-middle">Desa/Kelurahan</th>
                <th className="align-middle">Kecamatan</th>
                <th className="align-middle">Kategori</th>
                <th className="align-middle text-center">Detail</th>
                <th className="align-middle text-center">Data Backlog</th>
                <th className="align-middle text-center">Foto</th>
                {/* {user && user.role === "admin" && <th className="align-middle text-center">Aksi</th>} */}
                <th className="align-middle text-center">Aksi</th>
                <th className="align-middle text-center">Maps</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="12" className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="12" className="text-center py-4 text-danger">
                    {error}
                  </td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan="12" className="text-center py-4">
                    Tidak ada data yang ditemukan
                  </td>
                </tr>
              ) : (
                data.map((item, index) => {
                  if (!item) return null;
                  const itemNumber = (currentPage - 1) * itemsPerPage + index + 1;
                  
                  return (
                    <tr key={item.id || index}>
                      <td>{itemNumber}</td>
                      <td>{item.nomorUrut || '-'}</td>
                      <td>{item.nomorRumahPadaPeta}</td>
                      <td>{item.namaLengkapKK}</td>
                      <td>{item.alamatRumah}</td>
                      <td>{item.desaKelurahan}</td>
                      <td>{item.kecamatan}</td>
                      <td>{item.kategori}</td>
                      <td className="text-center">
                        <Button color="link" className="p-0" onClick={() => handleDetailModalOpen(item)}>
                          <FaEye style={{ color: "#007bff" }} />
                        </Button>
                      </td>
                      <td className="text-center">
                        {item.Backlogs && item.Backlogs.length > 0 ? (
                          <Button color="link" className="p-0" onClick={() => handleBacklogModalOpen(item)}>
                            <FaEye style={{ color: "#007bff" }} />
                          </Button>
                        ) : (
                          <span style={{ color: "#6c757d" }}>-</span>
                        )}
                      </td>
                      <td className="text-center">
  <Button color="link" className="p-0" onClick={() => handleFotoClick(item.id, item)}>
    <FaEye style={{ color: "#007bff" }} />
  </Button>
</td>
                      <td className="text-center">
                      <div className="d-flex justify-content-center align-items-center gap-2">
                      <Button outline color="link" className="p-0 me-2" onClick={() => handleEditClick(item)}>
      <FaEdit style={{ color: "#28a745" }} />
      Edit
    </Button>
                      {user && user.role === "admin" && (
                       
                          <div className="d-flex justify-content-center gap-2">
                            {/* <Button
                              outline
                              color="primary"
                              size="sm"
                              onClick={() => handleEditClick(item)}
                              className="d-flex align-items-center"
                            >
                              <FaEdit className="me-1" /> Edit
                            </Button> */}
                           
                            <Button
                              outline
                              color="danger"
                              size="sm"
                              onClick={() => deleteData(item.id)}
                              className="d-flex align-items-center"
                            >
                              <FaTrash className="me-1" /> Delete
                            </Button>
                           <Button
                            outline
                             size="sm"
                            color="success"
                           // color="danger"
  onClick={() => handleVerifikasiBantuan(item.id, { verifikasiBantuan: "Sudah Dapat Bantuan" })}
>
  <FaUserCheck style={{ color: "#4ccafcff" }}/> Verifikasi
</Button>

                          </div>
                        
                      )}
                      </div>
                      </td>
                      <td className="text-center">
                        <Button color="link" className="p-0" onClick={() => handleToggleExpand(index, item.id)}>
                          <FaEye style={{ color: "#007bff" }} />
                        </Button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>

        {/* Pagination */}
        <Row className="mt-4">
          <Col xs={12} className="d-flex flex-wrap justify-content-between align-items-center">
            <div className="items-per-page d-flex align-items-center mb-3 mb-md-0">
              <label htmlFor="itemsPerPage" className="me-2 mb-0">Tampilkan:</label>
              <select
                id="itemsPerPage"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                className="form-select form-select-sm"
                style={{ width: "80px" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span className="ms-2">per halaman</span>
            </div>

            <div className="pagination-info mb-3 mb-md-0">
              Menampilkan {data.length > 0 ? (currentPage - 1) * itemsPerPage + 1 : 0} - {Math.min(currentPage * itemsPerPage, (totalPages * itemsPerPage) - (itemsPerPage - data.length))} 
            </div>

            <div className="pagination d-flex">
              {/* <Button
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1 || isLoading}
                color="secondary"
                size="sm"
                className="me-1"
              >
                <FaAngleDoubleLeft />
              </Button> */}
              <Button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1 || isLoading}
                color="secondary"
                size="sm"
                className="me-1"
              >
                <FaAngleLeft />
              </Button>

              {getPageNumbers().map((pageNum, index) => (
                <React.Fragment key={index}>
                  {pageNum === '...' ? (
                    <span className="mx-1 pagination-ellipsis d-flex align-items-center">...</span>
                  ) : (
                    <Button
                      onClick={() => handlePageChange(pageNum)}
                      color={currentPage === pageNum ? "primary" : "secondary"}
                      size="sm"
                      className="mx-1"
                      disabled={isLoading}
                    >
                      {pageNum}
                    </Button>
                  )}
                </React.Fragment>
              ))}

              <Button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages || isLoading}
                color="secondary"
                size="sm"
                className="ms-1 me-1"
              >
                <FaAngleRight />
              </Button>
              {/* <Button
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages || isLoading}
                color="secondary"
                size="sm"
              >
                <FaAngleDoubleRight />
              </Button> */}
            </div>
          </Col>
        </Row>

        {/* Modals */}
        <LocationModal isOpen={modalOpen} onClose={() => setModalOpen(false)} selectedItem={selectedItem} />
       <PhotoModal 
  isOpen={showPhotoModal} 
  onClose={handleClosePhotoModal} 
  photoUrl={photoUrl}
  photoData={selectedItem}
/>
        <EditModal 
        isOpen={isModalOpen}
        toggle={handleModalToggle}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        onSave={handleSaveData}
      />
        <DetailInfoModal isOpen={isDetailModalOpen} onClose={handleDetailModalClose} detailData={detailData} />
        <DataBacklog isOpen={isBacklogModalOpen} onClose={handleBacklogModalClose} backlogData={backlogData} />
       
      </Container>
    </div>
  </div>
);
};

export default DataRecapComponent;